import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
var _localConfig;
import "core-js/modules/es.symbol.to-primitive.js";
import "core-js/modules/es.date.to-primitive.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.number.constructor.js";
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
export var FeatureFlagKey = /*#__PURE__*/function (FeatureFlagKey) {
  FeatureFlagKey["AgentEditorRewrite"] = "agent_editor_rewrite";
  FeatureFlagKey["RpAccountSettings"] = "rp_account_settings";
  FeatureFlagKey["RpAgentsRewrite"] = "rp_agents_rewrite";
  FeatureFlagKey["RpKycPilot"] = "rp_kyc_pilot";
  FeatureFlagKey["RpMerchPage"] = "rp_merch_page";
  FeatureFlagKey["RpPartnerBonusProgram"] = "rp_partner_bonus_program";
  FeatureFlagKey["RpProductMarketingFeatures"] = "rp_product_marketing_features";
  FeatureFlagKey["RpSpotlightCards"] = "rp_spotlight_cards";
  FeatureFlagKey["RpTaskTypeFilter"] = "rp_task_type_filter";
  FeatureFlagKey["RpTaskManagementDashboardWidget"] = "rp_task_management_dashboard_widget";
  FeatureFlagKey["RpAgentDashboardBanner"] = "rp_agent_dashboard_banner";
  FeatureFlagKey["RpStudentListBanner"] = "rp_student_list_banner";
  FeatureFlagKey["RpWhatsAppNotification"] = "rp_whatsapp_notification";
  FeatureFlagKey["UseAbidCustomizationLogin"] = "use-abid-customization-login";
  return FeatureFlagKey;
}({});
export var localConfig = (_localConfig = {}, _defineProperty(_localConfig, FeatureFlagKey.AgentEditorRewrite, {
  enabled: true
}), _defineProperty(_localConfig, FeatureFlagKey.RpAccountSettings, {
  enabled: true
}), _defineProperty(_localConfig, FeatureFlagKey.RpAgentsRewrite, {
  enabled: true
}), _defineProperty(_localConfig, FeatureFlagKey.RpKycPilot, {
  enabled: true
}), _defineProperty(_localConfig, FeatureFlagKey.RpMerchPage, {
  enabled: true
}), _defineProperty(_localConfig, FeatureFlagKey.RpPartnerBonusProgram, {
  enabled: true
}), _defineProperty(_localConfig, FeatureFlagKey.RpProductMarketingFeatures, {
  enabled: true
}), _defineProperty(_localConfig, FeatureFlagKey.RpSpotlightCards, {
  enabled: true
}), _defineProperty(_localConfig, FeatureFlagKey.RpTaskTypeFilter, {
  enabled: true
}), _defineProperty(_localConfig, FeatureFlagKey.RpAgentDashboardBanner, {
  enabled: true
}), _defineProperty(_localConfig, FeatureFlagKey.RpStudentListBanner, {
  enabled: true
}), _defineProperty(_localConfig, FeatureFlagKey.RpWhatsAppNotification, {
  enabled: true
}), _defineProperty(_localConfig, FeatureFlagKey.UseAbidCustomizationLogin, {
  enabled: true
}), _localConfig);